import React from "react";

import TablePagination from "../../../../../ui/widgets/table/pagination";
import { PAGE_SIZE } from "../../../types";
import { TablePagerProps } from "./types";

export default function Pager({
  pageNumber,
  count,
  onPageNumberChange,
}: TablePagerProps): React.JSX.Element {
  const onChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    onPageNumberChange(page);
  };

  return (
    <TablePagination
      count={count}
      onChangePage={onChangePage}
      page={pageNumber}
      rowsPerPage={PAGE_SIZE}
      rowsPerPageOptions={[PAGE_SIZE]}
    />
  );
}
